import { render } from "./ListBulletsIcon.vue?vue&type=template&id=1e6db534"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__